import { render } from "./GoToTopButton.vue?vue&type=template&id=088b3d82&scoped=true"
import script from "./GoToTopButton.vue?vue&type=script&lang=js"
export * from "./GoToTopButton.vue?vue&type=script&lang=js"

import "./GoToTopButton.vue?vue&type=style&index=0&id=088b3d82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088b3d82"]])

export default __exports__